module.exports = __webpack_public_path__ + "img/gangarhino.3539b49c.jpeg";